import React, { Fragment, useEffect } from "react";
// import { startEmptyCart } from "../../features/cart/cartActions";
import { RootState } from "../rootReducer";
import { useDispatch, useSelector } from "react-redux";
import { startEmptyCartOrder } from "../features/order/orderActions";

export const CartWatcherService = () => {
  const dispatch = useDispatch();
  const cartItemCount = useSelector(
    (state: any) => state.cart.cart.items.length
  );
  const cartInit = useSelector(
    (state: any) => state.cart.cartInitialized
  );
  useEffect(() => {
    if (
      cartItemCount == 0 &&
      cartInit &&
      !window.location.pathname.includes("table")
    ) {
      // dispatch(
      //   startEmptyCart({
      //     clearCartItems: true,
      //   })
     // );
      dispatch(startEmptyCartOrder())

    }
  }, [cartItemCount]);
  return <Fragment></Fragment>;
};
